import React from 'react';
import '../../general/General.css';
import { Navbar, Footer, Breadcrumbs } from "../../../components/shared";

const Kudamulukku2017ThanksNote = () => {
  return (
    <>
      <Navbar />
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs />
            <br />
            <p>குடமுழக்கு நன்னீராட்டு விழா-நன்றி மடல்</p>
            <p>25-வைகாசி-ஹேவிளம்பிவருடம்</p>
            <p>08-06-2017</p>
            <br />

            <p>
              பேரன்புடையீர், வணக்கம்.
              <br /><br />
              அருள்மிகு பெரியபொன்னாச்சியம்மன்கோயில் 1936ம்ஆண்டு பெரியவர்கள் திருப்பணிசெய்து அடுத்து 1985ம் ஆண்டு ராஜகோபுரம் கட்டி கோயில் திருப்பணிசெய்து குடமுழுக்கு நன்னீராட்டு விழா நடைபெற்றது. அதற்குபின் கோயில் முழுவதும் அகற்றி புதியதாகப் புதுப்பொலிவுடன் கோயில் கர்ப்பகிரஹம்,ராஜகோபுரம்-கல்லிலும் அர்த்தமண்டபம், மஹாமண்டபம், முன்மண்டபம், ராஜகோபுரம், தீபதம்பம், சுற்று மதில்சுவர் திருப்பணியை காண்போர் வியக்கும் வண்ணம் நிறைவு செய்து ஹேவிளம்பிவருடம் வைகாசி மாதம் 25ம் நாள் (08-06-2017) வியாழக்கிழமை காலை10.46மணிக்குமேல் 11.14 மணிக்குள் பெரியபொன்னாச்சியம்மன் கோயில் குடமுழக்கு நன்னீராட்டு விழா பல்லோர் பாராட்டும் வகையில் விண்ணோர் வியக்கும்வகையில் மிகமிக சீரும் சிறப்புடன் மிகவும் சிறப்பாக நடைபெற்றது.
            </p>
            <br />
            <h3>குடமுழக்கு நன்னீராட்டு விழாவை சிறப்பித்து அருளாசிவழங்கிய ஆன்றோர்கள்:</h3>
            <br />
            <ul>
              <li>மேலைசிதம்பரம் பேரூர் ஆதீனம் தவத்திரு. சாந்தலிங்க ராமசுவாமி அடிகள் அவர்கள்</li>
              <li>சிரவை ஆதீனம் தவத்திரு. குமரகுருபரசுவாமிகள் அவர்கள்.</li>
              <li>பேரூர் ஆதீனம் இளைபட்டம் தவத்திரு. மருதாசல அடிகள் அவர்கள்,</li>
              <li>கூனம்பட்டிசிவஸ்ரீ சரவண மாணிக்கசுவாமிகள் அவர்கள்.</li>
              <li>பெங்களூர் ஸ்ரீஸ்ரீகுருகுலம்சிவஸ்ரீஏ.ஏஸ்.சுந்தரமூர்த்தி சிவாச்சாரியார் அவர்கள்.</li>
              <li>திருப்பரங்குன்றம் ஸ்ரீஷகந்தகுரு வித்யாலய முதல்வர்.சிவஸ்ரீ எஸ்.கே.ராஜாபட்டர் ஆஅவர்கள்.</li>
              <li>கொடுமுடி. சிவஸ்ரீவீ.எஸ்.தண்டபாணி குருக்கள் அவர்கள், கே.ஆர்.சுந்தரகுருக்கள் அவர்கள்</li>
            </ul>


            <p>இக்குடமுழுக்குவிழாவை நமது <b>குலகுரு சிவஸ்ரீ ராஜமாணிக்கம்(எ) பாபு சிவாச்சாரியார்,தலைமையில்</b> கூத்தன்பூண்டி கே.ஆர். ரவிசந்திரசிவம் சிவாச்சாரியார் சர்வசாதகமும், கொடுமுடி சிவஸ்ரீமகேஷ்குருக்கள் சர்வபோதகம் நிகழ்த்தி சிறப்பாக நடத்தினர்.

            </p>

            <p>இத்திருக்கோயிலை நிர்மானிபபதில் ஆலயநிர்மான ஸ்தபதி புதுக்கோட்டை ராயபுரம் திரு.பி. குப்புசுவாமி அவர்களும்,ஆலய சிற்ப வேலைகளை சிற்பி.எம். லோகநாதன் அவர்களும் சிறப்பாக செய்தனர்.</p>
            <br />
            <p>இச்சிறப்பான விழாமலர் வெளியிட 1998ஆம் ஆண்டு இந்த மலரிலுள்ள அனைத்து செப்பேடு. கல்வெட்டு ஆவணங்களை சிறப்பாக தொகுத்து வழங்கிய புலவர் செ.இராசு. தலைவர் கல்வெட்டி இயல்துறை, தமிழ் பல்கலைக்கழகம், தஞ்சாவூர் அவர்களுக்கும். அவருக்கு உறுதுணையாயிருந்து பல அரிய ஆவணங்களை திரட்டிதந்த அத்திபாளையம் கவிஞர்.அ.பொ.கந்தசாமி அவர்களுக்கும் முதல் பிரதி 01-02-1998 அன்று வெளியிட மிகவும் சிரமம் மேற்கொண்ட தாராபுரம் வட்டம் செங்காட்டூர் அமரர்.எஸ்.ஆர்.பொன்னுசாமி அவர்களுக்கும் இந்த குடமுழுக்கு விழா சிறப்புமலர்
              வெளியிட உறுதுணையாய் இருந்த அனைத்து விளம்பரதாரர் அனைவருக்கும் நன்றினை தெரிவித்து கொள்கிறோம்.
            </p>
            <br />
            <p>கோயில்திருப்பணிக்கு மனமுவந்து நன்கொடை வாரிவழங்கிய நல்லுள்ளம் படைத்த வள்ளல் பெருந்தகையர்களுக்கும் அன்னதானம் சிறப்பாக நடைபெற அரிசி,மற்றும் அனைத்துபொருள்கள் மனம்குளிர வாரிவழங்கிய நல்மனம்படைத்த நல்லவர்களுக்கும்,  அனைத்து குடமுழுக்கு நன்னீராட்டு விழாப்பணி தொய்விலாமல் சிறப்பாக நடைபெற அயராது உழைத்திட்ட அத்துணை நன்மக்களுக்கும் திருக்கோயில் குடமுழுக்கு நன்னீராட்டுவிழாவில்  கோயில் புண்ணியமண்ணிலே பாதம் பதித்து அன்னை அருளமுதை பெற்ற அனைத்து பக்தகோடி பெருமக்களுக்கும்,</p>
            <br />
            <p>குடமுழக்குநன்னீராட்டுவிழா நிறைவுற்று மண்டலபூஜை நிறைவுநாள் ஹேவிளம்பி வருடம் ஆடி மாதம் 10ம் நாள் புதன்கிழமை (26-07-2017) நிகழ்வில் கலந்துகொண்ட பக்தகோடி மக்களுக்கும், 26.7.2017 அன்று நடைபெற்ற மண்டல பூஜை நிறைவு விழாவில் வெளியிட அருள்மிகு பொன்னாச்சியம்மன் திருக்கோயில் குடமுழக்கு நன்னீராட்டு விழாமலர் அச்சிட்டு கொடுத்த கொங்குகுரல் பதிப்பகம் மற்றும் கொங்குகுரல் மாத இதழ் ஆசிரியர் கொங்கு குரல் பி.கே. சின்னசாமி அவர்களுக்கும், குடமுழக்குவிழா திருப்பணிகுழு சார்பில் மனம்நிறைந்த இதயங்கனிந்தநன்றிதனை சிரம்தாழ்த்தி கரம் உயர்த்திகூப்பி மனமுவந்து வாழ்த்தி வணங்கி அத்துனை குடிபாட்டு குல மக்களும் நீண்ட ஆயுள் நிறைந்தசெல்வம் நோயற்றதேகம் பெற்று வாழ்வாங்கு வாழ வணங்குகிறோம். </p>
            <br />
            <p>நம்முடைய பொன்னாச்சியம்மன் கோயில் குடிபாட்டு மக்களுக்கு ஓர் அன்பான வேண்டுகோள்.
              தங்களுடைய குழந்தைகளுக்கு நம்முடைய குலதெய்வபெயர்நாமம் சூட்டி தினமும் குல தெய்வத்தை மறவாமல் இருப்பதற்கு, அன்றாடம் நம்முடைய குழந்தையின் பேரில் நம்முடைய  குலதெய்வத்தை அழைத்தால் நம் எதிர்கால சந்ததிகள் வளமாக வாழ்வார்கள். தற்சமயம் நம்  குடிபாட்டு மக்களிடையே 85 சதவீதம் ஆண்வாரிசு இல்லாமல் இருப்பதை அனைவரும் அறிவோம். அந்தக் குறையை தீர்க்க தாங்கள் தங்கள் மழலைகளுக்கு பொன்னாச்சியம்மன், கருமலை, கருப்பண்ணசாமி திருநாமம் சூட்டி எதிர்கால சந்ததிகள் வாழ்வாங்கு வாழ வளர வாழ்த்துகிறோம்.
            </p>
            <br /><br />
            <p>நன்றி, வணக்கம்.</p>
            <p>இங்ஙனம்,<br />
              திருப்பணி குழுவினர்,<br />
              அருள்மிகு பொன்னாச்சியம்மன் திருக்கோயில்,<br />
              விதரி அத்திப்பாளையம்,<br />
              அரவக்குறிச்சி வட்டம்,<br />
              கரூர் மாவட்டம்.
            </p>
            <br />
          </div>
        </div>
      </div>
      <Footer /></>
  );
}

export default Kudamulukku2017ThanksNote;
